var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSites(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_585_2240",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_585_2240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91016 17.4727V5.87109H16.418V17.4727",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91016 5.87109L7.08398 3.69141H17.2441L16.418 5.87109",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17.4727H0",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 3.69141V1.58203H14.2734V3.69141",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 -1.67638e-07V1.58203",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58203 17.4727V11.1445H7.91016",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58203 11.1445H0.527344V9.03516H7.91016",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69141 17.4727V15.3633H5.80078V17.4727",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16406 13.2539H6.32813",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_585_2240",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_585_2240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 17.4727V14.3086H14.2734V17.4727",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 14.3086V17.4727",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49219 7.98047H11.6367",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6914 7.98047H14.8008",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49219 10.0898H11.6367",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6914 10.0898H14.8008",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49219 12.1992H11.6367",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6914 12.1992H14.8008",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSites);
export default __webpack_public_path__ + "static/media/sites.80d08fdcf0851887097741068ab986e0.svg";
export { ForwardRef as ReactComponent };